/** Best efforts. HR is the containing set's average (a window sits inside one set). */
import { store } from '../state/store'
import { formatDuration, formatPace } from '../analytics/format'

function selectWindow(startOrdinal: number, endOrdinal: number): void {
  const ordinals: number[] = []
  for (let o = startOrdinal; o <= endOrdinal; o++) ordinals.push(o)
  store.setSelection(ordinals)
}

export function RecordsTable() {
  const records = store.records.value
  const stats = store.stats.value
  const unit = stats?.unit ?? 'm'

  return (
    <div class="card rows" style="overflow:hidden">
      <div class="card-pad" style="padding-bottom:10px">
        <div class="card-title">Best efforts</div>
      </div>
      {records.length === 0 ? (
        <div class="card-pad muted" style="padding-top:0">
          No qualifying distances for this pool length.
        </div>
      ) : (
        <>
          <div class="thead">
            <div style="width:62px">Effort</div>
            <div style="width:52px">Time</div>
            <div style="width:62px">Pace</div>
            <div style="flex:1">HR</div>
          </div>
          {records.map((r) => {
            const hr = stats?.stints[r.stintIndex]?.avgHr ?? null
            return (
              <div
                key={r.distance}
                class="row clickable"
                onClick={() => selectWindow(r.startOrdinal, r.endOrdinal)}
              >
                <div style="width:62px; font-weight:600">
                  {r.distance} {unit}
                </div>
                <div style="width:52px">{formatDuration(r.timeMs)}</div>
                <div style="width:62px" class="muted">
                  {formatPace(r.paceSecondsPer100)}
                </div>
                <div style="flex:1" class="hr-ink">{hr ? `${hr} bpm` : '—'}</div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
